import type * as React from "react";
import { type CSSProperties, type FC, type ReactNode } from "react";
import { Icon } from "./Icon";
import classNames from "classnames";
import { type IconType } from "./IconType";
import { type IconSize } from "./IconSize";

type DivProps = JSX.IntrinsicElements["div"];
export interface IconClickableProps extends DivProps {
  type: IconType;
  size?: IconSize;
  onIconClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  className?: string;
  /**
   * React CSSProperties
   */
  style?: CSSProperties;
  clickableType?: IconClickableType;
  disabled?: boolean;
  inverted?: boolean;
  id?: string;
  children?: ReactNode;
}

export enum IconClickableType {
  PRIMARY = "icon-clickable--primary",
  SECONDARY = "icon-clickable--secondary",
  INFO = "icon-clickable--info",
  WHITE = "icon-clickable--white",
  ERROR = "icon-clickable--error",
}

/**
 * @deprecated Double check with design team before using in a new place
 */
export const IconClickable: FC<IconClickableProps> = (props) => {
  const {
    type,
    onIconClick,
    clickableType = IconClickableType.PRIMARY,
    size,
    className,
    inverted,
    disabled,
    children,
    ...rest
  } = props;
  const iconClasses = classNames("icon-clickable", clickableType, className, {
    "icon-clickable--inverted": inverted,
    "icon-clickable--disabled": disabled,
  });
  return (
    <div className={iconClasses} onClick={onIconClick} {...rest}>
      <Icon type={type} size={size} />
      {children}
    </div>
  );
};
